import { 
  TableRow, 
  TableCell,
  Collapse
} from '@mui/material';
import WODetails from './WODetails';
import PropTypes from 'prop-types';

const MRTableRow = ({ row, index, MRcols, openRows}) => {
  return (
    <>
      <TableRow className='table-row' sx={{ '& > *': { borderBottom: 'unset' }, height: '40px' }}>
        {MRcols.map((field, colIndex) => (
          field.showCol ? 
            <TableCell align="left" key={colIndex} className={field?.rowClassName}>
              {field.cellContent(row, index)}
            </TableCell>
          : null
        ))}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
          <Collapse in={!!openRows[index]} timeout="auto" unmountOnExit>
            <WODetails rowData={row} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

MRTableRow.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
  openPhoneEdit: PropTypes.func,
  MRcols: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    cellContent: PropTypes.func,
    rowClassName: PropTypes.string,
    sortable: PropTypes.bool,
    showCol: PropTypes.bool,
    openRows: PropTypes.object
  }))
}

MRTableRow.defaultProps = {
  row: {},
  index: 0,
  openPhoneEdit: () => {},
  MRcols: [],
  openRows: {}
}

export default MRTableRow;